export enum Constants {
    week = 'week',
    month = 'month',
    day = 'day',
    eventAddedNotificationLabel = 'Event Added Successfully',
    eventDeletedNotificationLabel = 'Event Deleted Successfully',
    eventUpdatedNotificationLabel = 'Event Updated Successfully',
    eventAddedNotificationClass = 'scheduler__notification--success',
    eventDeletedNotificationClass = 'scheduler__notification--alert',
    startTime = 'Start Time',
    endTime = 'End Time',
    flagged = 'Flagged',
    cancelLabel = 'Cancel',
    createLabel = 'Create',
    deleteLabel = 'Delete'
}

